import { z } from 'zod';
import { LANGUAGE, SUPPORTED_LANGUAGES, USER_ROLE } from '../constants/index.js';
import { uuidSchema } from './common.schema.js';
const faqAudienceRoleSchema = z.enum([USER_ROLE.EMPLOYER, USER_ROLE.HELPER]);
const requiredTextSchema = z.string().trim().min(1).max(10000);
const sortOrderSchema = z.number().int().min(0).max(9999);
export const faqIdParamSchema = z.object({
    id: uuidSchema,
});
export const faqPublicListQuerySchema = z.object({
    role: faqAudienceRoleSchema.optional(),
    language: z
        .enum(SUPPORTED_LANGUAGES)
        .default(LANGUAGE.ZH_HANT)
        .transform((value) => {
        if (value === LANGUAGE.ZH_HANS) {
            return LANGUAGE.ZH_HANS;
        }
        if (value === LANGUAGE.ZH_HANT) {
            return LANGUAGE.ZH_HANT;
        }
        return LANGUAGE.EN;
    }),
});
export const createFaqInputSchema = z.object({
    audienceRole: faqAudienceRoleSchema,
    questionZhHant: requiredTextSchema,
    answerZhHant: requiredTextSchema,
    questionZhHans: requiredTextSchema,
    answerZhHans: requiredTextSchema,
    questionEn: requiredTextSchema,
    answerEn: requiredTextSchema,
    sortOrder: sortOrderSchema.default(0),
    isActive: z.boolean().default(true),
});
export const updateFaqInputSchema = z
    .object({
    audienceRole: faqAudienceRoleSchema.optional(),
    questionZhHant: requiredTextSchema.optional(),
    answerZhHant: requiredTextSchema.optional(),
    questionZhHans: requiredTextSchema.optional(),
    answerZhHans: requiredTextSchema.optional(),
    questionEn: requiredTextSchema.optional(),
    answerEn: requiredTextSchema.optional(),
    sortOrder: sortOrderSchema.optional(),
    isActive: z.boolean().optional(),
})
    .refine((value) => Object.keys(value).length > 0, {
    message: 'At least one field is required',
});
export const adminFaqListQuerySchema = z.object({
    role: faqAudienceRoleSchema.optional(),
    includeInactive: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .optional()
        .transform((value) => {
        if (typeof value === 'boolean') {
            return value;
        }
        if (value === 'true') {
            return true;
        }
        return false;
    }),
});
//# sourceMappingURL=faq.schema.js.map